import { useState } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Menu, X } from "lucide-react";

const links = [
  { key: "modules", href: "#moduli" },
  { key: "license", href: "#licenza" },
  { key: "security", href: "#sicurezza" },
  { key: "contact", href: "#contatto" },
];

export default function Nav() {
  const { locale, setLocale, t } = useLanguage();
  const [open, setOpen] = useState(false);

  return (
    <nav className="relative z-30 border-b border-white/10 px-6 py-5 backdrop-blur-md bg-[#0b131e]/80" data-testid="main-nav">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <a href="#" className="flex items-center gap-3" aria-label="Trust Master CRM" data-testid="brand-logo-link">
          <img src="/logo.png" alt="Trust Master CRM" className="h-9 w-auto" />
          <div className="leading-tight">
            <span className="block text-sm font-semibold tracking-wider text-white uppercase font-mono-code">Trust Master CRM</span>
            <span className="block text-[10px] text-white/50 tracking-widest uppercase">{t.nav.tagline}</span>
          </div>
        </a>

        <div className="hidden md:flex items-center gap-8 text-xs tracking-widest uppercase text-white/70 font-mono-code">
          {links.map((l) => (
            <a key={l.key} href={l.href} className="hover:text-[#E2C079] transition-colors" data-testid={`nav-${l.key}-link`}>
              {t.nav[l.key]}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <div className="flex border border-white/20 text-[10px] font-mono-code uppercase" data-testid="language-switcher">
            {["it", "en"].map((l) => (
              <button
                key={l}
                onClick={() => setLocale(l)}
                data-testid={`lang-${l}-button`}
                className={`px-2.5 py-1.5 transition-colors ${locale === l ? "bg-[#E2C079] text-[#0b131e] font-bold" : "text-white/60 hover:text-white"}`}
              >
                {l.toUpperCase()}
              </button>
            ))}
          </div>
          <a
            href="#licenza"
            data-testid="nav-buy-button"
            className="hidden md:inline-block px-4 py-2 border border-[#E2C079] text-[#E2C079] text-xs font-mono-code uppercase tracking-wider hover:bg-[#E2C079] hover:text-[#0b131e] transition-all duration-300"
          >
            {t.nav.buy}
          </a>
          <button
            className="md:hidden p-1 text-white"
            aria-label={open ? t.nav.closeMenu : t.nav.openMenu}
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((o) => !o)}
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden mt-4 pb-2 space-y-1" data-testid="mobile-menu">
          {links.map((l) => (
            <a
              key={l.key}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.key}-link`}
              className="block px-2 py-2 text-xs font-mono-code uppercase tracking-widest text-white/70 hover:text-[#E2C079]"
            >
              {t.nav[l.key]}
            </a>
          ))}
          <a
            href="#licenza"
            onClick={() => setOpen(false)}
            data-testid="mobile-nav-buy-button"
            className="block mt-2 px-4 py-2 border border-[#E2C079] text-[#E2C079] text-xs font-mono-code uppercase tracking-wider text-center"
          >
            {t.nav.buy}
          </a>
        </div>
      )}
    </nav>
  );
}
